<template>
  <div class="wrapper">
    <v-img class="logo" cover max-width="165" src="@/assets/images/logo/logo.svg?url" />
    <h1 class="mb-6">{{ $t('delete_account_title') }}</h1>
    <p v-if="canAccountBeDeleted" class="description">
      {{ $t('delete_account_content') }}
    </p>
    <p v-else class="description--inValid">
      {{ $t('delete_account_expire_content') }}
    </p>

    <dialog-error v-model:show-status="hasError" class="mb-3 errorDialog" :error="error" closed-icon />
    <success-in-dialog ref="successInDialog" class="mb-3 successDialog" :success-text="$t('snackbar_account_deletion_apply_success')" />

    <v-btn
      v-if="canAccountBeDeleted"
      width="100%"
      :height="40"
      color="orange50"
      variant="flat"
      :loading="shouldButtonLoadingShow"
      @click="deleteAccount"
    >
      {{ $t('delete_confirm') }}
    </v-btn>
    <v-btn v-else width="100%" :height="40" color="orange50" variant="flat" :loading="shouldButtonLoadingShow" @click="goToFaq">
      {{ $t('check_faq') }}
    </v-btn>
    <p class="bottomText mb-7">{{ companyAndYear }}</p>
  </div>
</template>

<script>
import tools from '@/mixin/tools'
import SuccessInDialog from '@/components/notice/success/success-in-dialog'
import DialogError from '@/components/notice/error/dialog-error'

export default defineNuxtComponent({
  name: 'AccountDeletionPage',
  components: {
    SuccessInDialog,
    DialogError,
  },
  mixins: [tools],
  async asyncData(nuxtApp) {
    const { $store: store, redirect, error, app, route, req } = nuxtApp
    const { query } = getNuxtContext(nuxtApp)
    const { token } = query

    if (token) {
      const canAccountBeDeleted = await store
        .dispatch('authentication/getCanAccountBeDeleted', token)
        .then(res => {
          if (res.code === 0) {
            return res.data.is_allow_deletion
          } else {
            return false
          }
        })
        .catch(error => {
          // 應該不會進這裡
          console.error(error)
          return false
        })

      return {
        canAccountBeDeleted,
        token,
      }
    } else {
      return { canAccountBeDeleted: false }
    }
  },
  setup() {
    const localePath = useLocalePath()
    return { localePath }
  },
  data() {
    return {
      isMobile: false,
      shouldButtonLoadingShow: false,
      hasError: false,
      error: {},
    }
  },
  computed: {
    companyAndYear() {
      return 'FunNow ' + this.$dayjs().year()
    },
  },
  mounted() {
    this.onResize()
  },
  methods: {
    onResize() {
      const isMobile = window.innerWidth < 600
      this.isMobile = isMobile
    },
    goToFaq() {
      location.href = `${location.origin}${this.localePath({ name: 'faq' })}`
    },
    deleteAccount() {
      this.shouldButtonLoadingShow = true
      this.hasError = false
      this.$store
        .dispatch('authentication/deleteAccount', this.token)
        .then(res => {
          this.shouldButtonLoadingShow = false
          if (res.code === 0) {
            this.$refs.successInDialog.show()
            location.replace('/')
          }
        })
        .catch(error => {
          this.shouldButtonLoadingShow = false
          this.hasError = true

          if (typeof error === 'string') {
            this.error = error
          } else {
            const i18nError = {
              ...error,
              message: error.code === 'offline' ? this.$t('snackbar_internet_unstable') : this.$t('snackbar_account_deletion_apply_failed'),
            }
            this.error = i18nError
          }

          console.error(error, error.message)
        })
    },
  },
})
</script>

<style lang="scss" scoped>
.wrapper {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 60px auto 0px;
  padding: 60px 40px;
  width: 440px;
  height: auto;

  .logo {
    margin-bottom: 24px;
    width: 165px;
  }

  h1 {
    font-weight: 400;
    font-size: 20px;
  }

  .description {
    width: 100%;
    margin-bottom: 40px;
    // for mobile
    &--inValid {
      width: 100%;
      margin-bottom: 40px;
    }
  }

  .errorDialog,
  .successDialog {
    margin-top: -16px;
    width: 100%;
  }

  .bottomText {
    display: none;
    font-size: 11px;
    color: $gray80;
    position: absolute;
    bottom: 0;
  }

  @include xxs {
    margin: initial;
    padding: 40px 20px;
    width: auto;
    height: calc(100% + 12px); // 12px is for cancelling Layout padding
    .logo {
      display: none;
    }
    .description {
      margin-bottom: 24px;
    }
    .errorDialog,
    .successDialog {
      margin-top: initial;
    }
    .bottomText {
      display: block;
    }
  }
}
</style>
